import React, { useEffect, useState } from "react";
import { Input, Button } from "antd";
import { Col, Row } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import { addTeamMembers } from "../../../redux/actions";
import { addTeamMembersReset } from "../../../redux/actions";
import history from "../../../routes/history";
import "./Add Member.css";
import { ArrowLeftOutlined } from "@ant-design/icons"
import TopAlert from "../../../components/TopNotification/TopAlert";
import { getCompanyProfileDetails,  } from "../../../redux/actions"; 

function Add_Member({ setShowModal }) {
  const [FullName, setFullName] = useState("");
  const [Email, setEmail] = useState("");
  const [JobTitle, setJobTitle] = useState("");
  const [MobilePhone, setMobilePhone] = useState("");
  const [fullNameauth, setFullNameauth] = useState("");
  const [jobTitleauth, setJobTitleauth] = useState("");
  const [Emailauth, setEmailauth] = useState("");
  const [mobilePhoneauth, setMobilePhoneauth] = useState("");
  const [Dimensions, setDimensions] = useState(getWindowDimensions());
  const [teamMemberHeader, setTeamMemberHeader] = useState(false)
  const dispatch = useDispatch();
  const loading = useSelector(
    (state) => state.TeamMembersReducer.AddMemberloading
  );

  var response = useSelector((state) => state.TeamMembersReducer.response);
  // const resp = useSelector(
  //   (state) => state.getCompanyProfileDetailsReducer.resp
  // );
  const resp = JSON.parse(localStorage.getItem("userProfile"))
  
 
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
 

  useEffect(() => {
    function handleResize() {
      setDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (response == "Sorry this user already exists") {
      setEmailauth("The email address is already being used");
      dispatch(addTeamMembersReset());
    }

    if (response?.InvitationId) {
      setTeamMemberHeader(true)
      setTimeout(() => {
        dispatch(
          addTeamMembersReset({
            FullName,
            EmailAddress: Email,
            JobTitle,
            PhoneNumber: MobilePhone,
            Source: window.location.href,
          })
        );

     
        Dimensions.width > 768 && history.push({
          pathname: '/myteams', 
          state: { defaultActiveKey: "2" }
        })      //(`/myteams`);
        Dimensions.width < 769 && setShowModal(false);
      }, 3000);


      
    }
  }, [response]);
  
  useEffect(() => {
    dispatch(getCompanyProfileDetails());
  }, []);

 
  

  const SubmitDetails = () => {
     
    var error_;
    var fullNameErr;
    var EmailErr;

    if (FullName === "" ) {
      error_ = true;
      setFullNameauth("Please add full name");
    }

    
    if (FullName.length) {
      const pattern = /^[a-zA-Z]{2,40}( [a-zA-Z]{2,40})+$/;

      if (pattern.test(FullName)) {
        setFullNameauth("");

        error_ = false;
        fullNameErr = false;
      } 
      else {
        setFullNameauth(
          "You must enter your first name (not just your initial) and last name separated by a space"
        );
        error_ = true;
        fullNameErr = true;
      }
    }
    if (JobTitle.trim() === "" ) {
      setJobTitleauth("Please add job title");
      error_ = true;
    } 
    
    else {
      setJobTitleauth("");
      error_ = false;
    }

    if (Email === "" ) {
      setEmailauth("Please add email address.");
      error_ = true;
    }

   
    
    if (Email.length) {
      const valid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    
       if(!(valid.test(Email))) {
        setEmailauth("Please enter a proper email address.");
        error_ = true;
        EmailErr = true;
      }
     else if (response == "Sorry this user already exists") {
        setEmailauth("The email address is already being used");
        error_ = true;
        EmailErr = true;
      dispatch(addTeamMembersReset());
      }
      else if( 
         (Email?.split('@')[1].split('.')[0] == resp?.EmailAddress?.split('@')[1].split('.')[0]) ||
         (Email?.split('@')[1].split('.')[0] == "example@skillgigs.com".split('@')[1].split('.')[0])
     ){
      setEmailauth("");
      error_ = false;
      EmailErr = false;
      }
      
      else{
      setEmailauth("You must use a company domain email");
      error_ = true;
      EmailErr = true;
      
       }
     
    //  else if (valid.test(Email) && (Email?.split('@')[1].split('.')[0] == resp?.EmailAddress?.split('@')[1].split('.')[0])) {
    //     setEmailauth("");
    //     EmailErr = false;
    //     error_ = false;
    //   }
      
      
      
    }

    

    if (MobilePhone === "" ) {
      setMobilePhoneauth("Please add phone number");
      error_ = true;
    } 
    
    else if (MobilePhone.length){
      var pattern =   /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;

      if (!pattern.test(MobilePhone)) { 
        setMobilePhoneauth("Please enter only numbers.");
        error_ = true;
      }
      else if(MobilePhone.length != 10){ 
        setMobilePhoneauth("Please enter valid phone number.");
        error_ = true;
      }
    }
    // else if (MobilePhone.length && (MobilePhone.toString()).includes('+') ){
    //   setMobilePhoneauth("Please enter valid phone number");
    //   error_ = true;
    // }

    // else if ((MobilePhone && MobilePhone.length < 10 )|| (MobilePhone && MobilePhone.length > 10))
    // {
    //   setMobilePhoneauth("Phone number should be consist of 10 digits");
    //   error_ = true;
    // }
   

    else {
      setMobilePhoneauth("");
      error_ = false;
    }

    if(!FullName.length || !JobTitle.length || !Email.length || !MobilePhone.length ){
      error_ = true;
    }


    if (error_ || fullNameErr || EmailErr) {
      return;
    } else {
      dispatch(
        addTeamMembers({
          FullName,
          EmailAddress: Email,
          CompanyName: "manuallyadded",
          JobTitle,
          PhoneNumber: MobilePhone,
          Source: window.location.href,
        })
      );
    }
  };

  useEffect(() => {
    const namePattern = /^[a-zA-Z]{2,40}( [a-zA-Z]{2,40})+$/;
    const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (FullName != "" && namePattern.test(FullName)) {
      setFullNameauth("");
    }
    if (Email != "" || emailPattern.test(Email)) {
      setEmailauth("");
    }
    if (MobilePhone != "") {
      setMobilePhoneauth("");
    }
    if (JobTitle != "") {
      setJobTitleauth("");
    }
  }, [FullName, Email, MobilePhone, JobTitle]);

  return (
    <div className="Add-Member-MainContainer">
       {teamMemberHeader && 
       <> 
            <TopAlert
            display={"block"}
            title={"Team member added successfully"}
            type="success"
            />  
         
            </>
      }
      {Dimensions.width > 768 && ( 
        <a 
        className="backdiv" 

        // style={{ display: "flex",
        //   flexDirection: "row", alignItems:'center', width:"40px",marginLeft:"4.5%"}}
          onClick={() => history.push("/myteams")}
          >
        <ArrowLeftOutlined className="back-icon"/>
            <div className="back-text">Back</div>
            </a>
          )}
      <div className="Add-Member-Container">
        <div className="Add-Member-SecContainer"> 
        {Dimensions.width > 768 && (
 
             
            <div style={{fontWeight:"bolder",}} className="Add-Member-Title">Add New Team Member</div>

        )}
          <Col style={{marginTop:Dimensions.width < 768? "-20px": "0px"}}  > 
            <div
              style={{
                padding: "1.2% 4%", 
              }}
            >
              <Row>
                {Dimensions.width < 768 ? (
                  <>
                    <div className="add-member-sub-title">Full Name</div>
                    <div className="per-asterik"> *</div>
                  </>
                ) : (
                  <div className="add-member-sub-title">
                    Full Name{" "}
                    <span className="text-style-1" style={{ color: "#db2828" }}>
                      *
                    </span>
                  </div>
                )}
              </Row>
              <Input
                type={"input"}
                className="per-inputfields"
                value={FullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Add first and last name here..."
              />
              {fullNameauth ? (
                <p className="perDetailErr" style={{marginBottom:'12px'}}>{fullNameauth}</p>
              ) : null}
              <Row>
                {Dimensions.width < 768 ? (
                  <>
                    <div className="add-member-sub-title">Work email</div>
                    <div className="per-asterik"> *</div>
                  </>
                ) : (
                  <div className="add-member-sub-title">
                    Work email{" "}
                    <span className="text-style-1" style={{ color: "#db2828" }}>
                      *
                    </span>
                  </div>
                )}
              </Row>
              <Input
                type={"email"}
                className="per-inputfields"
                value={Email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Add your email here..."
              />
             
              {Emailauth ? <p className="perDetailErr"  style={{marginBottom:'12px'}}>{Emailauth}</p> : null}
              <Row>
                {Dimensions.width < 768 ? (
                  <>
                    <div className="add-member-sub-title">Job Title</div>
                    <div className="per-asterik"> *</div>
                  </>
                ) : (
                  <div className="add-member-sub-title">
                    Job Title{" "}
                    <span className="text-style-1" style={{ color: "#db2828" }}>
                      *
                    </span>
                  </div>
                )}
              </Row>
              <Input
                type={"input"}
                className="per-inputfields"
                value={JobTitle}
                onChange={(e) => setJobTitle(e.target.value)}
                placeholder="Add gig title here..."
              />
              {jobTitleauth ? (
                <p className="perDetailErr"  style={{marginBottom:'12px'}}>{jobTitleauth}</p>
              ) : null}
              <Row>
                {Dimensions.width < 768 ? (
                  <>
                    <div className="add-member-sub-title">Phone Number</div>
                    <div className="per-asterik"> *</div>
                  </>
                ) : (
                  <div className="add-member-sub-title">
                    Phone Number{" "}
                    <span className="text-style-1" style={{ color: "#db2828" }}>
                      *
                    </span>
                  </div>
                )}
              </Row>
              <Input
                type="tel"
                className="per-inputfields"
                value={MobilePhone}
                onChange={(e) => {
                  // const valid =
                  //   /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;
                  // valid.test(e.target.value)
                  //   ?
                     setMobilePhone(e.target.value)
                    // : setMobilePhone("");
                }}
                placeholder="Add phone number here..."
              />
              {mobilePhoneauth ? (
                <p className="perDetailErr" >{mobilePhoneauth}</p>
              ) : null}




{Dimensions.width > 768 && (
              <hr
                style={{
                  marginTop: "2rem",
                }}
                color="#e4e4e4"
              />
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
                
              }}
            >
              <Button
            //   t r b l
            style={{
              // marginLeft:Dimensions.width < 768 && '12rem',
              //  marginRight:Dimensions.width < 768 &&'12px',
               
              // marginTop:Dimensions.width < 768 && '-0.5rem',
               marginBottom:Dimensions.width < 768 &&'2.5rem'
             }}
                className="button-add"
                onClick={() => SubmitDetails()}
                block={true}
              >
                {loading ? <LoadingOutlined /> : "Add"}
              </Button>
            </div>
            </div>

            
          </Col>
        </div>
      </div>
    </div>
  );
}

export default Add_Member;
